import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-card-tabbed.css.lit';
import tuftsCardComponentStyle from '../tufts-card/tufts-card.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-card/tufts-card';

import { tuftsCard } from '../tufts-card/tufts-card';
import '../tufts-tabs/tufts-tab-group/tufts-tab-group';

/**
 * The Tufts Card Tabbed component
 * @element tufts-card-tabbed
 * @summary Tufts Card Tabbed component
 *
 * Tabs will only be displayed if they have content in their respective slots.
 *
 */

@customElement('tufts-card-tabbed')
export class tuftsCardTabbed extends tuftsCard {
  static styles: CSSResultGroup = [
    tuftsCardComponentStyle,
    componentStyles,
    tuftsHeadingCssLit,
  ];

  render(): TemplateResult {
    // Check if content exists in each slot
    const hasMainContent = this.ngSlot.exist('content-0');
    const hasSecondContent = this.ngSlot.exist('content-1');
    this.isMobile = this.resizeController.currentBreakpointRange === 0;

    return html`
      <div class="main-wrapper ${this.isMobile ? 'mobile' : ''}">
        ${this.ngSlot.conditionalNGSlot('image')}
        <div class="title-wrapper">
          ${this.ngSlot.conditionalNGSlot('title')}
          ${this.ngSlot.conditionalNGSlot('year')}
          ${this.ngSlot.conditionalNGSlot('pronouns')}
        </div>
        <div class="contact-wrapper">
          ${this.ngSlot.conditionalNGSlot('phone')}
          ${this.ngSlot.conditionalNGSlot('email')}
        </div>
        ${hasMainContent || hasSecondContent
          ? html`
              <tufts-tab-group
                placement="top"
                padding="none"
                container-width="full"
                class="tab"
              >
                ${hasMainContent
                  ? html`
                      <tufts-tab slot="nav" panel="tab-number-0">
                        ${this.ngSlot.conditionalNGSlot('tab-title-0')}
                      </tufts-tab>
                      <tufts-tab-panel name="tab-number-0">
                        ${this.ngSlot.conditionalNGSlot('content-0-main')}
                        ${this.ngSlot.conditionalNGSlot('content-0')}
                      </tufts-tab-panel>
                    `
                  : ''}
                ${hasSecondContent
                  ? html`
                      <tufts-tab slot="nav" panel="tab-number-1">
                        ${this.ngSlot.conditionalNGSlot('tab-title-1')}
                      </tufts-tab>
                      <tufts-tab-panel name="tab-number-1">
                        ${this.ngSlot.conditionalNGSlot('content-1')}
                      </tufts-tab-panel>
                    `
                  : ''}
              </tufts-tab-group>
            `
          : ''}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-card-tabbed': tuftsCardTabbed;
  }
}
